import { PresetFilter } from '@/types/filterBuilder';

export const callPresets: PresetFilter[] = [
  // Status presets
  {
    id: 'completed-calls',
    label: 'Completed Calls',
    description: 'All calls that were answered',
    category: 'status',
    icon: 'CheckCircle',
    filters: { call_statuses: 'completed' },
  },
  {
    id: 'failed-calls',
    label: 'Failed Calls',
    description: 'Calls that failed to connect',
    category: 'status',
    icon: 'XCircle',
    filters: { call_statuses: 'failed' },
  },
  {
    id: 'voicemail-calls',
    label: 'Voicemail',
    description: 'Calls that went to voicemail',
    category: 'status',
    icon: 'Phone',
    filters: { had_voicemail: true },
  },
  {
    id: 'successful-calls',
    label: 'Successful Calls',
    description: 'Calls that achieved their purpose',
    category: 'status',
    icon: 'CheckCircle2',
    filters: { was_successful: true },
  },

  // Strategy presets
  {
    id: 'consent-calls',
    label: 'Consent Calls',
    description: 'All consent outreach calls',
    category: 'strategy',
    icon: 'FileCheck',
    filters: { strategy_types: 'CONSENT' },
  },
  {
    id: 'checkin-calls',
    label: 'Check-in Calls',
    description: 'Monthly check-in calls',
    category: 'strategy',
    icon: 'PhoneCall',
    filters: { strategy_types: 'CHECK_IN' },
  },
  {
    id: 'successful-consent',
    label: 'Successful Consent Calls',
    description: 'Consent calls where patient consented',
    category: 'strategy',
    icon: 'CheckCircle',
    filters: { strategy_types: 'CONSENT', was_successful: true },
  },
  {
    id: 'successful-checkin',
    label: 'Successful Check-ins',
    description: 'Check-in calls that were completed',
    category: 'strategy',
    icon: 'CheckSquare',
    filters: { strategy_types: 'CHECK_IN', was_successful: true },
  },

  // Time presets
  {
    id: 'today-calls',
    label: 'Today\'s Calls',
    description: 'Calls from today',
    category: 'time',
    icon: 'Calendar',
    filters: { days_ago: 1 },
  },
  {
    id: 'this-week',
    label: 'This Week',
    description: 'Calls from the last 7 days',
    category: 'time',
    icon: 'Calendar',
    filters: { days_ago: 7 },
  },
  {
    id: 'this-month',
    label: 'This Month',
    description: 'Calls from the last 30 days',
    category: 'time',
    icon: 'Calendar',
    filters: { days_ago: 30 },
  },

  // Schedule presets
  {
    id: 'scheduled-today',
    label: 'Scheduled Today',
    description: 'Calls scheduled for today',
    category: 'schedule',
    icon: 'Clock',
    filters: { scheduled_today: true },
  },
  {
    id: 'scheduled-this-week',
    label: 'Scheduled This Week',
    description: 'Calls scheduled for this week',
    category: 'schedule',
    icon: 'Clock',
    filters: { scheduled_this_week: true },
  },
];

function getPresetsByCategory(category: string): PresetFilter[] {
  return callPresets.filter((p) => p.category === category);
}

export function getCallPresetCategories(): { id: string; title: string; presets: PresetFilter[] }[] {
  return [
    { id: 'status', title: 'Call Status', presets: getPresetsByCategory('status') },
    { id: 'strategy', title: 'Strategy Type', presets: getPresetsByCategory('strategy') },
    { id: 'time', title: 'Time Range', presets: getPresetsByCategory('time') },
    { id: 'schedule', title: 'Scheduled Calls', presets: getPresetsByCategory('schedule') },
  ];
}
